import { render, staticRenderFns } from "./OrdersCard.vue?vue&type=template&id=77092655&scoped=true"
import script from "./OrdersCard.vue?vue&type=script&lang=js"
export * from "./OrdersCard.vue?vue&type=script&lang=js"
import style0 from "./OrdersCard.vue?vue&type=style&index=0&id=77092655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77092655",
  null
  
)

export default component.exports